import { csrfFetch, parseErrorResponse } from './csrf';
import { BaseSelfUserSchema, type BaseSelfUser, type Credentials } from './types';

/**
 * POST /api/login — session-based Django login.
 * Бросает Error с сообщением сервера при неуспехе.
 */
export async function loginRequest(credentials: Credentials): Promise<void> {
  const response = await csrfFetch('/api/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  });

  if (!response.ok) {
    throw new Error(await parseErrorResponse(response, 'Login failed'));
  }
}

/**
 * POST /api/logout — завершение сессии.
 * Не бросает: даже при недоступном сервере клиент очищает своё состояние.
 */
export async function logoutRequest(): Promise<void> {
  try {
    const response = await csrfFetch('/api/logout', { method: 'POST' });
    if (!response.ok) {
      console.error('Server logout failed, but client state is cleared anyway');
    }
  } catch (error) {
    console.error('Logout request failed, but client state is cleared anyway:', error);
  }
}

/**
 * GET /api/v3/users/self — текущий пользователь.
 * 401/403 — нормальное «не залогинен», возвращаем null.
 * `parse` позволяет приложению валидировать свой расширенный тип.
 */
export async function fetchSelf<TUser = BaseSelfUser>(
  parse: (data: unknown) => TUser = (data) => BaseSelfUserSchema.parse(data) as TUser,
): Promise<TUser | null> {
  const response = await csrfFetch('/api/v3/users/self');

  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      return null;
    }
    console.error(`Failed to fetch user: HTTP ${response.status}`);
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return parse(await response.json());
}
